import React from "react";
import Reveal from "./Reveal";
import { useLang } from "../lib/lang-context";
import { ArrowRight } from "@phosphor-icons/react";

export default function Process() {
  const { t } = useLang();
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32 bg-white dark:bg-zinc-950 border-t border-slate-200 dark:border-zinc-800"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="max-w-3xl mb-16">
          <p className="text-xs tracking-[0.24em] uppercase font-bold text-[var(--icor-blue)] eyebrow-line">
            {t.process.eyebrow}
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tighter mt-5 text-[var(--icor-navy)] dark:text-white text-balance">
            {t.process.title}
          </h2>
          <p className="mt-5 text-lg text-slate-600 dark:text-zinc-400 leading-relaxed">
            {t.process.subtitle}
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 dark:bg-zinc-800 border border-slate-200 dark:border-zinc-800">
          {t.process.steps.map((step, i) => (
            <Reveal
              key={i}
              delay={i * 120}
              className="bg-white dark:bg-zinc-950 p-8 group relative overflow-hidden transition-colors duration-300 hover:bg-[var(--icor-navy)] dark:hover:bg-[var(--icor-blue)]"
              data-testid={`process-step-${i}`}
            >
              <div
                className="absolute top-6 right-6 font-display text-6xl font-bold tracking-tighter text-slate-100 dark:text-zinc-900 select-none transition-colors group-hover:text-white/20"
                aria-hidden
              >
                {step.n}
              </div>
              <div className="relative">
                <div className="text-xs tracking-[0.18em] uppercase font-semibold text-[var(--icor-blue)] group-hover:text-blue-300 dark:group-hover:text-white transition-colors mb-4">
                  Paso {step.n}
                </div>
                <h3 className="font-display text-2xl font-medium tracking-tight text-[var(--icor-navy)] dark:text-white group-hover:text-white transition-colors mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-slate-600 dark:text-zinc-400 group-hover:text-white/80 transition-colors leading-relaxed">
                  {step.desc}
                </p>
                {i < t.process.steps.length - 1 && (
                  <ArrowRight
                    size={20}
                    className="mt-6 text-slate-300 dark:text-zinc-700 group-hover:text-white group-hover:translate-x-1 transition-all"
                  />
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
